import { render, staticRenderFns } from "./cropper-avator.vue?vue&type=template&id=053eb4d7&scoped=true"
import script from "./cropper-avator.vue?vue&type=script&lang=js"
export * from "./cropper-avator.vue?vue&type=script&lang=js"
import style0 from "./cropper-avator.vue?vue&type=style&index=0&id=053eb4d7&prod&scoped=true&lang=less"
import style1 from "./cropper-avator.vue?vue&type=style&index=1&id=053eb4d7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053eb4d7",
  null
  
)

export default component.exports